export default {
	getTotalDaysByYear: function(year) {
		return (new Date(year, 11, 31).getTime() - new Date(year, 0, 1).getTime()) / (24 * 60 * 60000) + 1;
	},

	//海翼周算法：如果一年中最后一天所在的周跨年了，则属于下一年的第一周
	getWeeksByYear: function(year) {
		year = parseInt(year);
	    
		if(!year || isNaN(year)) {
			year = new Date().getFullYear();
		}
		
	    var lastDay = year + '-12-31';
	    var day = new Date(lastDay).getDay();
	    var totalDays = this.getTotalDaysByYear(year);
	    if(day !== 6) {
	    	totalDays -= (day + 1);
	    }
	    return parseInt(totalDays / 7) + (totalDays % 7 > 0? 1 : 0);
	},
	
	getWeekString: function(date) {
	    if (!date) {
	        date = new Date();
	    }
	    date = new Date(date);
	    var year = date.getFullYear();
	    var firstDayOfYear = year + '-01-01';
	    var addDay = new Date(firstDayOfYear).getDay();
	    
	    var indexInThisYear = parseInt((date.getTime() - new Date(year, 0, 1).getTime()) / (24 * 60 * 60000));
	    var weekIndex = parseInt((indexInThisYear + addDay) / 7) + 1;
	    
	    var lastDayOfThisWeek = date.getTime() + (6 - date.getDay()) * 24 * 60 * 60000;
	    if(new Date(lastDayOfThisWeek).getFullYear() != year) {
	    	year ++;
	    	weekIndex = 1;
	    }

	    if(weekIndex < 10) {
	    	weekIndex = '0' + weekIndex.toString();
	    }

	    return year.toString() + weekIndex.toString();
	},

	getStartDateByWeek: function(week) {
		if (!week) {
	        return '';
	    }

	    if (typeof week === 'string') {
	        week = parseInt(week);
	    }

	    var year = Math.floor(week / 100);
	    var w = week % 100;
	    var weekDate = new Date(year, 0, 1);

	    weekDate.setDate((w - 1) * 7 + 1 - weekDate.getDay());

	    return weekDate;
	},
	
	getNextWeek: function(week) {
	    if (typeof week === 'string') {
	        week = week.replace(/-/g, '');
	        week = parseInt(week);
	    }
	    var year = Math.floor(week / 100);
	    var w = week % 100;
	    if (w < 52) {
	        return year * 100 + w + 1;
	    } 
	    if (w == 53) {
	        return (year + 1) * 100 + 1;
	    } 
	 
	    if (this.getWeeksByYear(year) == 52) {
	        return (year + 1) * 100 + 1;
	    } 

	    return year * 100 + w + 1;
	},

	getLastWeek: function(week) {
		if (typeof week === 'string') {
	        week = week.replace(/-/g, '');
	        week = parseInt(week);
	    }
	    var year = Math.floor(week / 100);
	    var w = week % 100;
	    if (w > 1) {
	        return year * 100 + w - 1;
	    } 
	    else {
	    	return (year - 1) * 100 + this.getWeeksByYear(year - 1)
	    }
	},

	format: function(date, format) {
		if(!date) {
	        return '';
	    }
	    if(/^\d{8}$/.test(date)) {
	        date = date.toString().replace(/(\d{4})(\d{2})/g, '$1/$2/');
		}
		
		if(Object.prototype.toString.call(date) == '[object String]' && date.indexOf("-") > -1){
			date = date.toString().replace(/-/g,"/")
		}
	    
	    var reg = {
	        yyyy: 'year',
	        mm: 'month',
	        dd: 'date',
	        hh: 'hours',
	        MM: 'minites',
	        ss: 'seconds',
	        ms: 'millSeconds'
	    }
	    
	    date = new Date(date);
	    var model = {
	        year: date.getFullYear(),
	        month: date.getMonth() + 1,
	        date: date.getDate(),
	        hours: date.getHours(),
	        minites: date.getMinutes(),
	        seconds: date.getSeconds(),
	        millSeconds: date.getMilliseconds()
	    }

	    if(!format){
	        format = 'yyyy-mm-dd';
	    }
	    
	    for(var key in reg){
	        var param = reg[key];
	        var val = model[param];
	        if(val.toString().length < 2){
	            val = '0' + val.toString();
	        }
	        format = format.replace(key, val);
	    }

	    return format;
	},

	getUTCTimespan: function(date) {
	    date = new Date(date);
	    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), 
	        date.getUTCSeconds(), date.getUTCMilliseconds() );

	    return date.getTime();
	},

	/**
	* 根据传入格式，使用UTC时间格式化输出
	* 格式化输出时间字符串
	* @param {date} date 时间值 - 可以为Timespane，或者'2015/01/01'、'2015-01-01'或其他可new Date()的时间字符串
	* @param {string} format 格式化输出方式 - yyyy年，mm月，dd天，hh小时，MM分钟，ss秒，ms，分秒
	* @returns {string} 格式化后的字符串
	*/
	formatUTC: function(date, format) {
	    if(!date) {
	        return '';
	    }
	    date = this.getUTCTimespan(date);
	    
	    return this.format(date, format);
	},

	/**
	* 根据传入格式，使用PDT时间格式化输出
	* 格式化输出时间字符串
	* @param {date} date 时间值 - 可以为Timespane，或者'2015/01/01'、'2015-01-01'或其他可new Date()的时间字符串
	* @param {string} format 格式化输出方式 - yyyy年，mm月，dd天，hh小时，MM分钟，ss秒，ms，分秒
	* @returns {string} 格式化后的字符串
	*/
	formatPDT: function(date, format) {
	    if(!date) {
	        return '';
	    }
	    date = this.getUTCTimespan(date);
	    
	    var pdtDate = date - 8 * 60 * 60000;
	    
	    return this.format(pdtDate, format);
	},
	
	/**
	* 根据传入格式，使用北京时间格式化输出
	* 格式化输出时间字符串
	* @param {date} date 时间值 - 可以为Timespane，或者'2015/01/01'、'2015-01-01'或其他可new Date()的时间字符串
	* @param {string} format 格式化输出方式 - yyyy年，mm月，dd天，hh小时，MM分钟，ss秒，ms，分秒
	* @returns {string} 格式化后的字符串
	*/
	formatCN: function(date, format) {
	    if(!date) {
	        return '';
	    }
	    date = this.getUTCTimespan(date);
	    
	    var cnData = date + 8 * 60 * 60000;
	    
	    return this.format(cnData, format);
	},


	/**
	* 根据传入格式，格式必须为 '2015-12-12 13:01:01'
	* 格式化本地时间的Timespan
	* @param {str} 时间字符串 - '2015-01-01'、'2015-01-01 12'、 '2015-01-01 12:11'、'2015-01-01 12:12:12'格式
	* @returns {number} number timespan
	*/
	getLocaleTimespan: function(str) {
	    if(!str || typeof str !== 'string') {
	        return null;
	    }

	    str = str.replace(/(^\s*)|(\s*$)/g, ''); 
	    if(str.length < 10) {
	        return null;
	    }

	    if(str.length === 10) { //2015-12-11格式
	        str += ' 00:00:00';
	    }
	    else if(str.length === 13) { //2015-12-11 12 格式
	        str += ':00:00';
	    }

	    return new Date(str).getTime();
	},

	//todo: 移除
	compare: function(date1, date2){
	    if(typeof date1 == 'string'){
	        date1 = date1.replace(/-/g, '/');
	    }
	    if(typeof date2 == 'string'){
	        date2 = date2.replace(/-/g, '/');
	    }

	    date1 = new Date(date1).getTime();
	    date2 = new Date(date2).getTime();

	    return date1 - date2;
	}  
}



// WEBPACK FOOTER //
// ./src/js/date.js